<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="goback">
        <div @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="search">
        <div class="pick">
          <div class="newDate" @click="showPickDate = true">
            {{ newDate }}
          </div>
          <i class="el-icon-date"></i>
          <van-popup v-model="showPickDate" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="year-month"
              title="选择年"
              :min-date="minDate"
              :max-date="maxDate"
              :columns-order="['year', 'month']"
              @confirm="comfirmPickTime"
              @cancel="showPickDate = false"
            />
          </van-popup>
        </div>
        <div class="pick">
          <el-input
            v-model="searchValue"
            placeholder="请输入姓名"
            clearable
            @input="getList"
          ></el-input>
        </div>
      </div>
      <div class="content" v-if="list.length > 0">
        <div class="item_list" v-for="item in list" :key="item.id" @click="toUrl(item)">
          <div class="left">
            <div class="name">给{{ item.evaluatePersonnelName }}的考评结果</div>
            <div class="time">{{ item.evaluateDate }}</div>
          </div>
          <div class="right">详情 > </div>
        </div>
      </div>
      <div class="kong_con" v-else>
        <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
        <div class="kong_title kong_title1">您还没有考评记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/evaluation";
export default {
  components: {},
  data() {
    return {
      searchValue: "",
      showPickDate: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      newDate: moment(new Date()).format("YYYY-MM"),
      userinfo: {},
      list: [],
    };
  },
  mounted() {
    const loginEvaluation = JSON.parse(sessionStorage.getItem("loginEvaluation"));
    if (loginEvaluation) {
       this.userinfo = loginEvaluation;
    } else {
      this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    }
    // this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    this.getList();
  },
  methods: {
    // 跳转
    toUrl(item) {
      this.$router.push({
        path: "/evaluation/questionsDetail",
        query: { id: item.id },
      });
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    //选择日期
    comfirmPickTime(value) {
      this.newDate = moment(value).format("YYYY-MM");
      this.currentDate = value;
      this.showPickDate = false;
      this.getList();
    },
    //获取考评列表
    getList() {
      let json = {
        page: 1,
        pageSize: 999,
        orderDate: this.newDate,
        evaluatorCode: this.userinfo.username,
        name: this.searchValue,
      };
      api.evaluateManageList(json).then((res) => {
        if (res.code == 200) {
          console.log(res, "res");
          this.list = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  padding-top: 30px;
  background: url("~@/assets/evaluation/bg2.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  // 隐藏滚动条
  ::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }

  .goback {
    margin: 0 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
    }

    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 30px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 30px;
    margin: 45px auto;
    .pick {
      width: 48%;
      height: 90px;
      border-radius: 30px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      margin-bottom: 15px;
      ::v-deep {
        .el-input {
          height: 100%;
        }
        .el-input__inner {
          border: none !important;
          width: 100%;
          height: 100%;
        }
      }
      .newDate {
        flex: 1;
        // height: 40px;
      }
      div {
        color: #969b9e;
        font-size: 30px;
      }
      i {
        color: #969b9e;
      }
    }
  }
  .content {
    // background: #fff;
    border-radius: 50px 50px 0 0;
    flex: 1;
    padding: 0 40px 40px;
    position: relative;
    overflow: auto;
    .item_list{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      background: #fff;
      border-radius: 30px;
      padding: 30px;
      margin-bottom: 30px;
      box-shadow: 0px 3px 7px 0px rgba(152, 152, 152, 0.17);
      font-size: 30px;
      .time{
        color: #91929E;
        margin-top: 20px;
      }
      .right{
        color: #1FBE8A;
      }
    }
  }
  .kong_con {
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    justify-content: center;
    .kong_img {
      width: 450px;
      height: 450px;
    }
    .kong_title1 {
      margin-top: 30px !important;
    }
    .kong_title {
      color: #999999;
      font-size: 26px;
      margin-top: 10px;
    }
  }
}
</style>
